import { Pipe, PipeTransform } from "@angular/core";

const DEFAULT_IMAGE = "assets/images/portrait/small/noAvatar.jpg";

@Pipe({
    name: "imageCheck",
    standalone: false
})
export class ImageCheckPipe implements PipeTransform {
  transform(
    value: string,
    size: string | null = null,
    override: string | null = null,
    defaultSrc = DEFAULT_IMAGE
  ): Promise<string> {
    if (!defaultSrc) defaultSrc = DEFAULT_IMAGE;
    if (override != null && override != "")
      return new Promise<string>((resolve) => {
        resolve(override);
      });
    if (!value)
      return new Promise<string>((resolve) => {
        resolve(defaultSrc);
      });

    var image = new Image();
    image.src = size != null ? value + size : value;
    return new Promise<string>((resolve) => {
      image.onload = () => {
        resolve(image.src);
      };
      image.onerror = () => resolve(defaultSrc);
    });
  }
}
